import {
    Box, Button, styled, CircularProgress,
} from '@mui/material';
import { PlayArrow, RestartAlt } from '@mui/icons-material';

const ActionsBar = styled(Box)(({ theme }) => ({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 3),
}));

type LoadResetButtonProps = {
    uri: string;
    isLoading?: boolean;
    onLoad?: (uri: string) => void;
    onReset?: () => void;
    productKey?: string;
    productVersion?: number;
};

export const LoadResetButtons = ({
    uri, isLoading = false, onLoad, onReset, productKey, productVersion,
}: LoadResetButtonProps): JSX.Element => {
    const canLoad = !!uri.trim() && !!productKey?.trim() && !!productVersion && !isLoading;

    const handleLoad = (): void => {
        if (!canLoad) {
            return;
        }
        onLoad?.(uri.trim());
    };

    const handleReset = (): void => {
        onReset?.();
    };

    return (
        <ActionsBar>
            <Button
                color="secondary"
                disabled={!uri || isLoading}
                startIcon={<RestartAlt />}
                variant="outlined"
                onClick={handleReset}
            >
                Reset
            </Button>
            <Button
                color="primary"
                disabled={!canLoad}
                startIcon={isLoading ? <CircularProgress size={20} /> : <PlayArrow />}
                variant="contained"
                onClick={handleLoad}
            >
                {isLoading ? 'Loading...' : 'Load'}
            </Button>
        </ActionsBar>
    );
};
